import React from 'react';
import PropTypes from 'prop-types';
import LabeledSelect from '../LabeledSelect';
import LabeledTextInput from '../LabeledTextInput';
import states from '../../../constants/states';
import withValidation from '../../shared/withValidation';

const defaultProps = {
  options: [],
};

class LabledStatesInput extends React.PureComponent {
  render() {
    const { CountryValue } = this.props;

    switch (CountryValue) {
      case 'Canada': {
        return <LabeledSelect {...this.props} options={states.Canada} />;
      }
      case 'USA': {
        return <LabeledSelect {...this.props} options={states.USA} />;
      }
      case 'Other':
      default: {
        return <LabeledTextInput {...this.props} />;
      }
    }
  }
}

LabledStatesInput.propTypes = {
  CountryValue: PropTypes.string,
};

LabledStatesInput.defaultProps = defaultProps;
export default withValidation(LabledStatesInput);



// WEBPACK FOOTER //
// src/components/shared/LabledStatesInput/index.jsx